'use strict';

var _ = require('lodash');

module.exports = class RuleSet {
    /**
     * Creates a rule set object.
     * @param  {Object} config The configuration to build the object with
     * @return {RuleSet}
     */
    constructor(config) {
        validate(config);

        this._whiteList = config.whiteList;
        this._rules = config.rules || [];
    }

    get whiteList() {
        return this._whiteList;
    }

    get rules() {
        return this._rules;
    }
};

function validate(config) {
    if (_.isNil(config)) {
        throw new Error('config must not be null or undefined.');
    }

    if (_.isNil(config.whiteList)) {
        throw new Error('config.whiteList must not be null or undefined.');
    }
}
